var i = Object.defineProperty;
var C = (t, s, o) => s in t ? i(t, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[s] = o;
var c = (t, s, o) => C(t, typeof s != "symbol" ? s + "" : s, o);
class h {
  constructor() {
    // 事件池
    c(this, "pools", {});
  }
  // 移除事件监听
  remove(s, o, e) {
    const a = this.pools[s] && this.pools[s][o];
    a && (this.pools[s][o] = a.filter((n) => n !== e));
  }
  // 清空全部事件，由于单一实例，多次注册会被共享内容
  clear(s) {
    this.pools[s] = {};
  }
  // 注册事件监听
  on(s, o) {
    return this.pools[s] || (this.pools[s] = {}), this.pools[s][o.name] || (this.pools[s][o.name] = []), this.pools[s][o.name].push(o.callback), this.pools[s][o.name].includes(o.callback);
  }
  // 触发事件
  emit(s, o, ...e) {
    this.pools[s] || (this.pools[s] = {});
    const a = this.pools[s][o];
    a && a.forEach((n) => {
      try {
        n(...e);
      } catch (E) {
        console.error(`${o} monitor event exception！`, E);
      }
    });
  }
}
const r = new h(), A = "onSave", p = "changeCatalogVisible", L = "changeFullscreen", R = "pageFullscreenChanged", g = "fullscreenChanged", N = "previewChanged", G = "previewOnlyChanged", H = "htmlPreviewChanged", S = "catalogVisibleChanged", d = "buildFinished", T = "errorCatcher", I = "replace", D = "uploadImage", O = "openModals", u = "ctrlZ", f = "ctrlShiftZ", P = "catalogChanged", F = "pushCatalog", V = "rerender", b = "eventListener", m = "taskStateChanged";
export {
  d as B,
  L as C,
  T as E,
  g as F,
  H,
  O,
  R as P,
  I as R,
  m as T,
  D as U,
  p as a,
  r as b,
  A as c,
  f as d,
  u as e,
  b as f,
  V as g,
  N as h,
  G as i,
  S as j,
  P as k,
  F as l
};
